import React, { useEffect } from 'react';
import TitleBar from '../components/TitleBar';
import Footer from '../components/Footer';

function Home({ isEmbedded, error, tenant }) {
    const data = { name: "Campaigns Platform App", tenant: tenant };
    // Declare effects using useEffect
    useEffect(() => {
        document.title = 'CPA - Form';
    }, []);

    return (
        <div id="home" >
            {!isEmbedded && <TitleBar key="title" data={data} />}
            <div className="e-card nofocus nohover">
                <div className="col-lg-12 pb-5 pt-5">
                    <div className="e-card-content">
                        <div className="content-wrapper">
                            {!error && (
                                <div>
                                    <h3>Welcome to the Campaigns Forms</h3>
                                    <br />
                                    <p>Our online platform empowers citizens to submit and promote campaigns to their constituency representative and government offices. Whether you are concerned about the environment, social justice, healthcare, education, or any other cause.</p>
                                    <p>Submitting a campaign is easy and straightforward. Click on the link provided to you from your chosen subscription.</p>
                                    <p>If you're a vendor who would like to use our platform to host your campaigns, we welcome you to join our community. Our user-friendly interface makes it easy for you to create and manage your campaigns.</p>
                                    <p>At campaigns.org.uk, we believe that everyone has the power to make a difference. By joining forces with others and raising your voice, you can help create positive change in your local area and beyond. So why wait? Start your campaign today and be the change you want to see in the world!</p>
                                </div>)}

                            {error && ( 
                                <div>
                                    <h3>Unable to load the Campaign Form</h3>
                                    <br />
                                    <p>{error}</p>
                                </div>
                            )}
                        </div>
                    </div>                             
                </div>
            </div>
            {!isEmbedded && <Footer tenant={tenant} />}
        </div>
    );
}

export default Home;
